import React from "react";
import { Icon } from "./Icon";

interface Check32Props {
  size?: number;
  className?: string;
  color?: string;
}

export const Check32: React.FC<Check32Props> = ({ size, className, color }) => {
  return (
    <Icon size={size} className={className} color={color}>
      <path d="M843.68 264.972c12.717 12.272 13.078 32.53 0.81 45.248l-432.278 448.001c-12.042 12.48-31.834 13.094-44.63 1.389l-186.531-170.666c-13.039-11.933-13.938-32.173-2.008-45.213 11.93-13.037 32.171-13.936 45.21-2.006l163.54 149.632 410.64-425.577c12.272-12.718 32.531-13.080 45.248-0.808z" />
    </Icon>
  );
};
